import { Observable } from 'rxjs'
import { StateObservable, ofType, combineEpics } from 'redux-observable'
import { uniq } from 'lodash-es'
import { GlobalState } from 'store'
import { SelectionActions, SelectionActionTypes } from 'store/selection'
import { map } from 'rxjs/operators'
import { AuditActions } from 'api/AuditActions'
import { BTQAction } from 'epics'

type AddAuditSubscriptionAction = ReturnType<typeof SelectionActions.addAuditSubscriptions>
type RemoveAuditSubscriptionAction = ReturnType<typeof SelectionActions.removeAuditSubscriptions>
type ClearAuditSubscriptionAction = ReturnType<typeof SelectionActions.clearAuditSubscriptions>
type AuditSubscriptionAction = AddAuditSubscriptionAction | RemoveAuditSubscriptionAction

export function auditEditSubscriptionEpic(
  action$: Observable<BTQAction>,
  state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return action$.pipe(
    ofType<
      BTQAction,
      SelectionActionTypes.ADD_AUDIT_SUBSCRIPTIONS | SelectionActionTypes.REMOVE_AUDIT_SUBSCRIPTIONS,
      AuditSubscriptionAction
    >(SelectionActionTypes.ADD_AUDIT_SUBSCRIPTIONS, SelectionActionTypes.REMOVE_AUDIT_SUBSCRIPTIONS),
    map(() => {
      const allOrderIds = Object.values(state$.value.selectionStore.windows).reduce(
        (orderIds, windowSelection) => orderIds.concat(windowSelection.auditSubscriptions),
        [] as string[]
      )

      if (allOrderIds.length === 0) {
        return AuditActions.unsubscribeAll()
      }

      return AuditActions.subscribe(uniq(allOrderIds))
    })
  )
}

export function auditClearSubscriptionsEpic(action$: Observable<BTQAction>): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, SelectionActionTypes.CLEAR_AUDIT_SUBSCRIPTIONS, ClearAuditSubscriptionAction>(
      SelectionActionTypes.CLEAR_AUDIT_SUBSCRIPTIONS
    ),
    map(() => {
      return AuditActions.unsubscribeAll()
    })
  )
}

export const auditSubscriptionEpic = combineEpics(auditEditSubscriptionEpic, auditClearSubscriptionsEpic)
